export default __webpack_public_path__ + "static/pay_compare_comp1_active-ef7ce2acbad736d05dc4294e2f8c521b.png";